// AUTO-GENERATED GraphQL Builder for ReuploadSubmit
import * as Builders from '../';
export class ReuploadSubmitBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  ok(){ return this.add('ok'); }
  remaining(){ return this.add('remaining'); }
}
